<template>

  <div class="cf">
    <div class="cf-success">

      <span class="cf-success__icon cf-success__icon--muted">–</span>

      <div class="cf-stack" style="gap:10px;align-items:center">
        <span class="cf-eyebrow cf-eyebrow--muted">Decyzja</span>
        <h1 class="cf-h1">Dziękujemy za cierpliwość</h1>
        <p class="cf-lead" style="margin:0 auto">W tej chwili nie jesteśmy w stanie zaproponować Ci pożyczki.
          Zapraszamy do skorzystania z naszej oferty w przyszłości.</p>
      </div>

    </div>
  </div>

</template>

<script>

    import { bus } from './main';

        

    export default {
     
       name: 'ZetosRejectView',
 

       data(){

            return {

            }
       },


       methods: {



        gotomain(){

            this.$router.push({path: '/'});
        }
       },



       mounted(){



            // scroll to top with .5s delay
            this.pageTop();

       }



        
    }
</script>

<style scoped>

.cf-page {
  padding: 44px 64px 56px;
  max-width: 960px;
}

.cf-easycheck__widget {
  padding: 24px;
  display: flex;
  justify-content: center;
}

@media (max-width: 900px) {

  .cf-page {
    padding: 24px 18px 40px;
  }
}

</style>



// WEBPACK FOOTER //
// src/ZetosRejectView.vue